export default "__VITE_PUBLIC_ASSET__eded367e__"